export enum TrackType {
    open = 'open',
    review = 'review',
    finished = 'finished',
}
